import { ChatMessageID } from '../models/chat';
import { IChatConversationMessage } from '../ng-services/chat.store';
import { groupBy } from './groupBy';

/**
 * We want to sort in an DESCENDING order. If we had integers, we could just return `first - second`.
 * Our Message ID can be either number or string, so we need to handle this case.
 *
 * @param first
 * @param second
 */
export function sortChatMessages(first: { id: ChatMessageID }, second: { id: ChatMessageID }) {
    // -1 -> first  < second
    //  0 -> first  = second
    //  1 -> second < first

    // Returning NaN would keep the elements in place, while moving all new numeric IDs at the end.
    // If you have a bunch of failed-to-send messages and send a new one, the new one ends up behind the failed ones.
    // This is the behavior we had before checking the types of ID.
    if (typeof first.id === 'string' || typeof second.id === 'string') {
        return NaN;
    }

    // Keep those conditions to easily swap the logic
    // if (typeof first.id === 'string' && typeof second.id === 'string') {
    //     return 0; // don't even try to sort strings. It probably means we are working with GUID as an `id`.
    // }
    //
    // if (typeof first.id === 'string') {
    //     return 1; // move it after numeric
    // }
    //
    // if (typeof second.id === 'string') {
    //     return -1; // keep it in position after numeric
    // }

    // this will sort numbers in DESC order
    return first.id - second.id;
}

export function groupChatMessages(chatMessages: IChatConversationMessage[]) {
    return groupBy(chatMessages, (a, b) => {
        if (a.owner?.id !== b.owner?.id) {
            return { ownerChanged: true };
        }

        const firstDate = new Date(a.created_at);
        const secondDate = new Date(b.created_at);

        const timeDiff = secondDate.getTime() - new Date(firstDate).getTime();

        // split groups if no new messages in one hour.
        if (timeDiff > 60 * 60 * 1000) {
            return { timeDiff: true };
        }

        // check if day changed
        if (firstDate.toDateString() !== secondDate.toDateString()) {
            return { dayChanged: true };
        }

        return null;
    });
}
